/**
 * Web-designed home hero: image paths, photo dates (yyyy-mm-dd), and translation keys.
 * Managers can later edit dates or copy via CMS — values are centralized here.
 */
export const WEB_HERO_SLIDE_DEFS = [
  { id: 'sunset', image: '/images/Sunset.jpg', photoDate: '2024-08-14' },
  { id: 'lake', image: '/images/lake.JPG', photoDate: '2024-07-22' },
  { id: 'fishgrill', image: '/images/fishgrill.JPG', photoDate: '2024-09-03' },
  { id: 'sunrise', image: '/images/levedesoleil.JPG', photoDate: '2024-06-11' },
  { id: 'milkyway', image: '/images/milkyway.JPG', photoDate: '2024-10-05' },
] as const;

export type WebHeroSlideId = (typeof WEB_HERO_SLIDE_DEFS)[number]['id'];
